import type { ReactNode } from "react";
import { cn } from "@/utils/cn";
import { Tooltip } from "./Tooltip";

type KpiTileProps = {
  // ReactNode (not string) so the cost tile can render a label like
  // "Cost <span>/100g</span>" with mixed formatting.
  label: ReactNode;
  children: ReactNode;
  tooltip?: { label: string; sublabel?: string };
  onClick?: () => void;
  accent?: boolean;
  dim?: boolean;
};

export function KpiTile({
  label,
  children,
  tooltip,
  onClick,
  accent,
  dim,
}: KpiTileProps) {
  const inner = (
    <div
      className={cn(
        "kpi-tile",
        accent && "accent",
        dim && "dim",
        onClick && "clickable"
      )}
      onClick={onClick}
    >
      <span className="kpi-tile-label">{label}</span>
      <div className="kpi-tile-content">{children}</div>
    </div>
  );
  return tooltip ? (
    <Tooltip label={tooltip.label} sublabel={tooltip.sublabel}>
      {inner}
    </Tooltip>
  ) : (
    inner
  );
}
